webpackJsonp([194455906138313],{

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _digitalRealities = __webpack_require__(21);
	
	var _digitalRealities2 = _interopRequireDefault(_digitalRealities);
	
	var _SlideshowFooter = __webpack_require__(8);
	
	var _SlideshowFooter2 = _interopRequireDefault(_SlideshowFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var id = 4;
	var video = '#';
	var prev = '/digital-realities/vr_colony-square';
	var next = '/digital-realities/vr_hotel-avalon';
	
	var listItems = _digitalRealities2.default[id].scope.map(function (item) {
	    return _react2.default.createElement(
	        'li',
	        null,
	        item
	    );
	});
	
	var DigitalRealities = function DigitalRealities(props) {
	    return _react2.default.createElement(
	        'div',
	        { id: 'digital-reality-landing' },
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'IMBIBE - Digital Realities: ',
	                _digitalRealities2.default[id].name
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'IMBIBE - Digital Realities: ' + _digitalRealities2.default[id].name }),
	            _react2.default.createElement('link', { rel: 'stylesheet', type: 'text/css', charset: 'UTF-8', href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css' }),
	            _react2.default.createElement('link', { rel: 'stylesheet', type: 'text/css', href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css' })
	        ),
	        _react2.default.createElement(
	            'id',
	            { id: 'hero' },
	            _react2.default.createElement('img', { src: _digitalRealities2.default[id].hero })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        _digitalRealities2.default[id].name
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _digitalRealities2.default[id].copy
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'Scope of Work:'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        listItems
	                    ),
	                    _digitalRealities2.default[id].video && _react2.default.createElement(
	                        'a',
	                        { href: _digitalRealities2.default[id].video, className: 'button special small' },
	                        'Watch Video'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_SlideshowFooter2.default, { vr: true, prev: prev, next: next })
	    );
	};
	
	exports.default = DigitalRealities;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-digital-realities-vr-atlanta-financial-center-js-4ecad3ade062fbe13cac.js